import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ReconSocialProfileEntity } from './recon-social-profile.entity';

/**
 * Links between social profiles that represent the same person
 * across different platforms.
 */
@Entity('recon_identity_links')
@Index(
	'idx_recon_identity_unique',
	['primaryProfileId', 'linkedProfileId', 'deletedDate'],
	{
		unique: true,
	},
)
export class ReconIdentityLinkEntity extends BaseEntity {
	// Links two profiles as same person
	@Column('int', { name: 'primary_profile_id', unsigned: true })
	public primaryProfileId!: number;

	@Column('int', { name: 'linked_profile_id', unsigned: true })
	public linkedProfileId!: number;

	// Matching info
	@Column('decimal', { name: 'match_confidence', precision: 3, scale: 2 })
	public matchConfidence!: number;

	/**
	 * Method used to match.
	 * 'bio_link', 'name_company', 'manual', 'email', 'website'
	 */
	@Column('varchar', { name: 'match_method', length: 50 })
	public matchMethod!: string;

	/**
	 * Factors that contributed to the match.
	 * ['name', 'company', 'bio_link']
	 */
	@Column('json', { name: 'matched_on', nullable: true })
	public matchedOn!: string[] | null;

	// Verification
	@Column('tinyint', { name: 'verified', width: 1, default: 0 })
	public verified!: boolean;

	@Column('int', { name: 'verified_by', unsigned: true, nullable: true })
	public verifiedBy!: number | null;

	@Column('datetime', { name: 'verified_at', nullable: true })
	public verifiedAt!: Date | null;

	// Relations
	@ManyToOne(() => ReconSocialProfileEntity)
	@JoinColumn({ name: 'primary_profile_id' })
	public primaryProfile?: ReconSocialProfileEntity;

	@ManyToOne(() => ReconSocialProfileEntity)
	@JoinColumn({ name: 'linked_profile_id' })
	public linkedProfile?: ReconSocialProfileEntity;
}
